fragment LargeTopicFeatureFragment on largeTopicFeature_Entry {
  id
  typeHandle
  mainEntry {
    ...EntryReferenceFragment
  }
  featuredArticle {
    ...ArticlePreviewFragment
  }
  featuredArticleImage {
    url
    title
  }
  featuredArticleTopic {
    ...EntryReferenceFragment
  }
  featuredArticleCategory {
    ...EntryReferenceFragment
  }
  articles {
    ...ArticlePreviewFragment
  }
}
